export default __webpack_public_path__ + "static/media/product-coupon.1c91aa9e.png";